"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.practiceTransition = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../helpers");
const taskStore_1 = require("../../../taskStore");
const pulseOkButton_1 = require("../helpers/pulseOkButton");
const replayButtonHtmlId = 'replay-btn-revisited';
const practiceTransition = (getPrompt, forceRun = false) => {
    const isKeyboardEnabled = (0, taskStore_1.taskStore)().task === 'trog' && (0, taskStore_1.taskStore)().isRoarApp;
    return {
        timeline: [
            {
                type: plugin_html_multi_response_1.default,
                data: () => {
                    return {
                        assessment_stage: 'instructions',
                    };
                },
                stimulus: () => {
                    const imageFilename = isKeyboardEnabled ? 'rocket' : 'rocket@2x';
                    const imageSrc = __1.mediaAssets.images[imageFilename];
                    const t = (0, taskStore_1.taskStore)().translations;
                    let textKey = 'generalYourTurn';
                    if (getPrompt) {
                        textKey = getPrompt();
                    }
                    const promptText = t[(0, helpers_1.camelize)(textKey)];
                    return `<div class="lev-stimulus-container">
                  ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                  <div class="lev-row-container instruction">
                    <p>${promptText}</p>
                  </div>
                  <div class="lev-stim-content-x-3">
                      <img
                          src=${imageSrc}
                          alt="Image not loading: ${imageSrc}. Please continue the task."
                      />
                  </div>
                </div>`;
                },
                prompt_above_buttons: true,
                button_choices: ['Continue'],
                button_html: () => {
                    const t = (0, taskStore_1.taskStore)().translations;
                    return `<button class="primary">${t.continueButtonText}</button>`;
                },
                keyboard_choices: isKeyboardEnabled ? ['Enter'] : 'NO_KEYS',
                post_trial_gap: 350,
                on_load: () => {
                    let audioKey = 'generalYourTurn';
                    if (getPrompt) {
                        audioKey = getPrompt();
                    }
                    const audioConfig = {
                        restrictRepetition: {
                            enabled: false,
                            maxRepetitions: 2,
                        },
                        onEnded: () => {
                            (0, pulseOkButton_1.pulseOkButton)(3000, (0, taskStore_1.taskStore)().totalTrialCount);
                        },
                    };
                    helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioKey)], audioConfig);
                    const pageStateHandler = new helpers_1.PageStateHandler((0, helpers_1.camelize)(audioKey), true);
                    (0, helpers_1.setupReplayAudio)(pageStateHandler);
                    (0, helpers_1.addExperimenterButtons)();
                    (0, helpers_1.setupFullscreenButton)();
                },
                on_finish: () => {
                    helpers_1.PageAudioHandler.stopAndDisconnectNode();
                },
            },
        ],
        conditional_function: () => {
            if ((0, taskStore_1.taskStore)().runCat || forceRun) {
                return true;
            }
            // only run this if coming out a practice phase into a test phase
            const runTrial = (0, taskStore_1.taskStore)().nextStimulus.trialType !== 'instructions' &&
                (0, taskStore_1.taskStore)().nextStimulus.assessmentStage !== 'practice_response' &&
                !(0, taskStore_1.taskStore)().testPhase;
            if (runTrial) {
                (0, taskStore_1.taskStore)('testPhase', true);
            }
            return runTrial;
        },
    };
};
exports.practiceTransition = practiceTransition;
